<template>
  <div id="project3S2S">
		<el-card :class="detailShow? 'hiddencard' : ''">
			<el-form :model="searchForm" ref="searchForm" label-position="top">
				<el-row>
					<el-col :md="6">
						<el-form-item label="Project Name:" prop="projectName">
							<el-input clearable v-model="searchForm.projectName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :md="6">
						<el-form-item label="IPMS ID/PMS ID:" prop="ipmsId">
							<el-input clearable v-model="searchForm.ipmsId" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :md="6">
						<el-form-item label="Country:" prop="salesRegion">
							<el-select clearable filterable v-model="searchForm.salesRegion" placeholder="Please select">
								<el-option
									v-for="item in salesRegionList"
									:key="item"
									:label="item"
									:value="item"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :md="6">
						<el-form-item label="Application Owner:" prop="projectManager">
							<el-select
								v-model="searchForm.projectManager"
								clearable
								filterable
								remote
								placeholder="Please input"
								:remote-method="value => remoteMethod('applicationOwnerList', value)"
							>
								<el-option v-for="(item, index) in applicationOwnerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :md="6">
						<el-form-item label="Project Order:" prop="secondEquipmentOrderCode">
							<el-input clearable v-model="searchForm.secondEquipmentOrderCode" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :md="6">
						<el-form-item label="Product Order:" prop="firstEquipmentOrderCode">
							<el-input clearable v-model="searchForm.firstEquipmentOrderCode" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :md="6">
						<el-form-item label="Service Contract:" prop="firstServiceOrderCode">
							<el-input clearable v-model="searchForm.firstServiceOrderCode" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :md="6">
						<el-form-item label="Account Name:" prop="customerName">
							<el-input clearable v-model="searchForm.customerName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :md="24" style="padding: 34px 0 0 0px; text-align: right;">
						<el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
						<el-button size="small" @click="handleReset()">Reset</el-button>
						<el-button size="small" :loading="exportLoading" @click="handleExport()">Export</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
        <el-table-column prop="projectName" label="Project Name" align="left" min-width="160" fixed="left" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<a style="color:blue;" @click="openDetail(scope.row, scope.row.editable === true)">{{ scope.row.projectName }}</a>
					</template>
				</el-table-column>
				<el-table-column prop="ipmsId" label="IPMS ID/PMS ID" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
       	<el-table-column prop="salesRegion" label="Country" align="center" min-width="155" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="customerName" label="Account Name" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
       	<el-table-column prop="secondEquipmentOrderCode" label="Project Order" align="center" min-width="135" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="firstEquipmentOrderCode" label="Product Order" align="center" min-width="135" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="firstServiceOrderCode" label="Service Contract" align="center" min-width="135" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="s3s2sManagementStartDate" label="3S2S Management Project Start Date" align="center" min-width="180" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{ scope.row.s3s2sManagementStartDate ? moment(scope.row.s3s2sManagementStartDate).format('YYYY-MM-DD') : '' }}
					</template>
				</el-table-column>
        <el-table-column prop="projectManagerDesc" label="Current Handler" align="center" min-width="135" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="s3s2CancelReason" label="Cancel Reason" align="center" min-width="120" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="operation" label="Operation" width="130" align="center">
					<template slot-scope="scope">
						<el-dropdown trigger="click" v-if="canOperate(scope.row) && scope.row.s3s2ApplicationStatus !== 'Cancel'">
							<el-button size="mini" type="primary">Operation<i class="el-icon-arrow-down el-icon--right"></i></el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item><el-button size="mini" type="primary" @click="openDetail(scope.row, canOperate(scope.row))">Finish Application</el-button></el-dropdown-item>
								<el-dropdown-item><el-button size="mini" type="warning" @click="openChangePm(scope.row)">Change PM</el-button></el-dropdown-item>
								<el-dropdown-item v-if="isSystemAdmin()"><el-button size="mini" type="primary" @click="openModify(scope.row)">Modify</el-button></el-dropdown-item>
								<el-dropdown-item v-if="isSystemAdmin() && scope.row.s3s2ApplicationStatus !== 'Postpone'"><el-button size="mini" type="warning" @click="handlePostpone(scope.row)">Postpone</el-button></el-dropdown-item>
								<el-dropdown-item v-if="isSystemAdmin() && scope.row.s3s2ApplicationStatus === 'Postpone'"><el-button size="mini" type="success" @click="handleResume(scope.row)">Resume</el-button></el-dropdown-item>
								<el-dropdown-item v-if="isSystemAdmin()"><el-button size="mini" type="danger" @click="openCancel(scope.row)">Cancel</el-button></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
      </el-table>

			<div class="pageDiv" v-if="totalCount && totalCount > 0">
				<el-pagination
					small
					layout="total, prev, pager, next, sizes, jumper"
					:page-sizes="[10, 20, 50, 100]"
					:current-page="currentPage"
					:page-size="pageSize"
					:total="totalCount"
					@size-change="changePageSize"
					@current-change="changePage"
				>
				</el-pagination>
			</div>
		</el-card>
		<detail
			v-if="detailShow"
			:id="detailId"
			page="myFlow"
			:flowCanEdit="canEdit"
			:hideSubmit="hideSubmit"
			:disableProjectLevel="disableProjectLevel"
			@closeDetail="closeDetail"
		/>
		<el-dialog title="Change PM" :visible.sync="changePmDialogVisible" width="450px" :close-on-click-modal="false">
			<el-form label-width="100px">
				<el-form-item label="New PM:">
					<el-select
						v-model="changePmForm.newPm"
						clearable
						filterable
						placeholder="Please input"
					>
						<el-option v-for="(item, index) in pmAllList" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button size="small" @click="changePmDialogVisible = false">Cancel</el-button>
				<el-button size="small" type="primary" :loading="changePmLoading" @click="confirmChangePm">Confirm</el-button>
			</div>
		</el-dialog>
		<el-dialog title="Project Cancel" :visible.sync="cancelDialogVisible" width="500px" :close-on-click-modal="false">
			<el-form :model="cancelForm" ref="cancelForm" label-width="170px">
				<el-form-item label="Project Cancel Reason:" prop="reason" :rules="[{ required: true, validator: validateReason, trigger: 'blur' }]" style="padding: 0">
					<el-input type="textarea" :rows="4" v-model="cancelForm.reason" maxlength="500" show-word-limit placeholder="Please input" />
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button size="small" @click="cancelDialogVisible = false">Cancel</el-button>
				<el-button size="small" type="primary" :loading="cancelLoading" @click="confirmCancel">Confirm</el-button>
			</div>
		</el-dialog>
  </div>
</template>
<script>
	import detail from '../../major/projectApplication/index.vue'
  import moment from 'moment'
  export default {
    name: 'project3S2S',
		components: {
			detail
		},
    created () {
			this.getCountry();
			this.getPmList();
			this.handleSearch()
    },
    data () {
      return {
				moment,
				salesRegionList: [],
				applicationOwnerList: [],
        searchForm: {},
				tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 1,
				exportLoading: false,
				detailShow: false,
				detailId: '',
				hideSubmit: false,
				disableProjectLevel: false,
				changePmDialogVisible: false,
				changePmLoading: false,
				pmAllList: [],
				changePmForm: {
					rowId: '',
					newPm: '',
				},
				cancelDialogVisible: false,
				cancelLoading: false,
				cancelForm: {
					rowId: '',
					reason: '',
				},
      }
    },
    methods: {
			canOperate(row) {
				const roleName = sessionStorage.getItem('roleName') || '';
				const domainAccount = localStorage.getItem('DOMAIN_ACCOUNT') || '';
				const allowedRoles = ['ServiceManager', 'SystemAdmin', 'ProjectManager（HQ）'];
				const hasRole = allowedRoles.some(role => roleName.indexOf(role) !== -1);
				const isCurrentHandler = row.projectManager === domainAccount;
				return hasRole || isCurrentHandler;
			},
			isSystemAdmin() {
				const roleName = sessionStorage.getItem('roleName') || '';
				return roleName.indexOf('SystemAdmin') !== -1;
			},
			getCountry() {
				let url =`${this.$store.state.islhurl}projectManager/fuzzyQueryBySalesRegion?salesRegion=`;
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				this._post(url, params).then(
					res => {
						this.salesRegionList = res;
					}
				)
			},
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			handleSearch() {
				let params = {
					...this.searchForm,
					pageSize: this.pageSize,
					pageNum: this.currentPage,
				}
				this.tableLoading = true;
				const searchParams = new URLSearchParams();
				Object.entries(params).forEach(([key, value]) => {
					searchParams.append(key, value);
				});
				let url =`${this.$store.state.islhurl}project/3s2s/list?${searchParams.toString()}`
				this._get(url,params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
						this.tableData = res.data;
						this.totalCount = res.totalSize;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			handleReset() {
				this.searchForm = {};
			},
			handleExport() {
				this.exportLoading = true;
				const date = new Date();
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				let params = {
					...this.searchForm,
				}
				const searchParams = new URLSearchParams();
				Object.entries(params).forEach(([key, value]) => {
					searchParams.append(key, value);
				});
				this.$axios({
					url: `${this.$store.state.islhurl}project/3s2s/export?${searchParams.toString()}`,
					method: 'get',
					responseType: "blob"
				}).then(response=>{
					this.exportLoading = false;
					const blob = new Blob([response.data])
					const aEle = document.createElement('a');     // 创建a标签
					const href = window.URL.createObjectURL(blob);       // 创建下载的链接
					aEle.href = href;
					aEle.download = 'Project3S2S_'+ year + month + day +'.xlsx';  // 下载后文件名
					document.body.appendChild(aEle);
					aEle.click();     // 点击下载 
					document.body.removeChild(aEle); // 下载完成移除元素
					window.URL.revokeObjectURL(href) // 释放掉blob对象
				})
			},
			openDetail(record, canEdit) {
				const domainAccount = localStorage.getItem('DOMAIN_ACCOUNT') || '';
				this.hideSubmit = false;
				this.disableProjectLevel = record.projectManager === domainAccount;
				this.detailShow = true;
				this.detailId = record.id;
				this.canEdit = canEdit
			},
			openModify(record) {
				this.hideSubmit = true;
				this.disableProjectLevel = false;
				this.detailShow = true;
				this.detailId = record.id;
				this.canEdit = true;
			},
			closeDetail(type) {
				this.detailShow = false;
				this.detailId = '';
				this.hideSubmit = false;
				this.disableProjectLevel = false;
				this.handleSearch();
			},
			openChangePm(row) {
				this.changePmForm.rowId = row.id;
				this.changePmForm.newPm = '';
				this.changePmDialogVisible = true;
			},
			getPmList() {
				let url = `${this.$store.state.islhurl}majorProjectManager/fuzzyQueryByName?empName=`;
				let params = {
					islhToken: sessionStorage.getItem('islhtoken'),
				}
				this._post(url, params).then(
					res => {
						if (res) {
							this.pmAllList = res;
						}
					}
				)
			},
			confirmChangePm() {
				if (!this.changePmForm.newPm) {
					this.$message.warning('Please select a New PM');
					return;
				}
				this.changePmLoading = true;
				let url = `${this.$store.state.islhurl}project/3s2s/changePm?projectId=${this.changePmForm.rowId}&empCode=${this.changePmForm.newPm}`;
				this._post(url).then(
					res => {
						this.changePmLoading = false;
						if (res.code === 200) {
							this.$message.success('Change PM Successfully!');
							this.changePmDialogVisible = false;
							this.handleSearch();
						} else {
							this.$message.error(res.message || 'Failed!');
						}
					}
				).catch(() => {
					this.changePmLoading = false;
				})
			},
			handlePostpone(row) {
				this.$confirm('Are you sure to postpone this project?', 'Confirm', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					let url = `${this.$store.state.islhurl}project/3s2s/postpone?projectId=${row.id}`;
					this._post(url).then(
						res => {
							if (res.code === 200) {
								this.$message.success('Postpone Successfully!');
								this.handleSearch();
							} else {
								this.$message.error(res.message || 'Failed!');
							}
						}
					)
				}).catch(() => {})
			},
			handleResume(row) {
				this.$confirm('Are you sure to resume this project?', 'Confirm', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					let url = `${this.$store.state.islhurl}project/3s2s/resume?projectId=${row.id}`;
					this._post(url).then(
						res => {
							if (res.code === 200) {
								this.$message.success('Resume Successfully!');
								this.handleSearch();
							} else {
								this.$message.error(res.message || 'Failed!');
							}
						}
					)
				}).catch(() => {})
			},
			openCancel(row) {
				this.cancelForm.rowId = row.id;
				this.cancelForm.reason = '';
				this.cancelDialogVisible = true;
				this.$nextTick(() => {
					this.$refs.cancelForm && this.$refs.cancelForm.clearValidate();
				});
			},
			validateReason(rule, value, callback) {
				if (!value || !value.trim()) {
					callback(new Error('Please input'));
				} else {
					callback();
				}
			},
			confirmCancel() {
				this.$refs.cancelForm.validate((valid) => {
					if (!valid) return;
					this.$confirm('Are you sure to cancel this project?', 'Confirm', {
						confirmButtonText: 'Confirm',
						cancelButtonText: 'Cancel',
						type: 'warning'
					}).then(() => {
						this.cancelLoading = true;
						let url = `${this.$store.state.islhurl}project/3s2s/cancel?projectId=${this.cancelForm.rowId}&cancelReason=${encodeURIComponent(this.cancelForm.reason)}`;
						this._post(url).then(
							res => {
								this.cancelLoading = false;
								if (res.code === 200) {
									this.$message.success('Cancel Successfully!');
									this.cancelDialogVisible = false;
									this.handleSearch();
								} else {
									this.$message.error(res.message || 'Failed!');
								}
							}
						).catch(() => {
							this.cancelLoading = false;
						})
					}).catch(() => {})
				});
			},
		},
  }
</script>
<style lang="less" scoped>
#project3S2S {
	.hiddencard {
		height: 0;
		overflow: hidden;
	}
	/deep/.el-table .cell {
		word-break: break-word;
	}
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 0px;
			padding: 0 15px 0 0;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 0px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	
	/deep/.el-dialog__body {
		padding: 10px 20px;
		.el-form {
			padding: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/project3S2S/index.vue